import {appFetch, AppFetchResponse} from "../utils/appFetch";
import {ManagerFormValuesProps} from "../components/shopManagers/NewShopManagerModal";
import {BlackoutDateProps} from "../types/BlackoutPeriod";

export const GetCreditList = async (domain: string): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `shop/credit/list`,
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
        },
        domain,
    });
}